import { Routes } from '@angular/router';
import { authGuard } from './core/guard/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/Auth/login/login').then((m) => m.Login),
  },




  {
    path: 'auth/forgot-password',
    loadComponent: () =>
      import('@auth/forgot-password/forgot-password').then((m) => m.ForgotPassword),
  },



  {
    path: 'account/activate',
    loadComponent: () =>
      import('@auth/activate-account/activate-account').then((m) => m.ActivateAccount)

  },


  {
    path: 'set-password',
    loadComponent: () =>
      import('@auth/reset-password/reset-password').then((m) => m.ResetPassword),
  },
  {
    path: 'auth/verify-otp',
    loadComponent: () => import('@auth/verify-otp/verify-otp').then((m) => m.VerifyOtp),
  },
  {
    path: 'account/reset-password',
    loadComponent: () =>
      import('@auth/reset-password/reset-password').then((m) => m.ResetPassword)

  },






  {
    path: 'home',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/Main/home/home').then((m) => m.Home),
  },
  {
    path: 'bookings',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/Main/booking/booking').then((m) => m.BookingComponent),
  },
  {
    path: 'transactions',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/Main/transactions/transactions').then((m) => m.TransactionsComponent),
  },
  {
    path: 'checkout',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/Main/checkout/checkout').then((m) => m.CheckoutComponent),
  },
  {
    path: 'validate-qr',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/Main/validate-qr/validate-qr').then((m) => m.ValidateQrComponent),
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/Main/profile/profile').then((m) => m.Profile),
  },
  {
    path: '**',
    redirectTo: 'login',
    pathMatch: 'full',
  },
];
